import type {
  GetConditionFieldPathProps,
  SchemaBuilderConditionFormValue,
} from "./schema-builder-condition.type";
import type {
  SchemaOperatorBasic,
  SchemaCondition,
  SchemaFieldConditionLegacy,
} from "@/entities/schema";

import {
  isSchemaConditionValue,
  isSchemaOperatorEmpty,
} from "@/entities/schema";
import { parseStringValue } from "@/utilities/string";

export const getConditionFieldPath = ({
  field,
  formListName,
  parentName,
}: GetConditionFieldPathProps) => {
  let fieldPath: (string | number)[] = [];

  // List parent
  if (parentName) fieldPath.push(parentName);

  // List
  if (typeof formListName === "string") fieldPath.push(formListName);
  else fieldPath = [...fieldPath, ...formListName];

  // Current field
  const fieldIndex = field.name;
  fieldPath.push(fieldIndex);

  return fieldPath;
};

export const getConditionsFormValuesFromSchema = (
  conditions?: SchemaFieldConditionLegacy | SchemaCondition[]
): SchemaBuilderConditionFormValue[] => {
  // Handle legacy format
  if (isSchemaConditionValue(conditions)) {
    const condition = getConditionFormValueFromSchema(conditions);
    return [condition];
  }

  if (!conditions?.length) return [];

  return conditions.map(getConditionFormValueFromSchema);
};

export const getConditionFormValueFromSchema = (
  schema: SchemaCondition
): SchemaBuilderConditionFormValue => {
  return {
    model: schema.model,
    operator: schema.condition,
    value: schema.value ? `${schema.value}` : undefined,
  };
};

export const getSchemaConditionsFromValues = (
  formValues?: SchemaBuilderConditionFormValue[]
): SchemaCondition[] => {
  if (!formValues?.length) return [];
  return formValues.map(getSchemaConditionFromValue);
};

export const getSchemaConditionFromValue = (
  formValue: SchemaBuilderConditionFormValue
): SchemaCondition => {
  const { model, operator, value } = formValue;

  if (isSchemaOperatorEmpty(operator)) {
    return { model, condition: operator };
  }

  return {
    model,
    condition: operator as SchemaOperatorBasic,
    value: value ? parseStringValue(value) : null,
  };
};
